import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { map } from 'rxjs/operators';
import { LoginService } from '../../services/login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-otp-confirmation',
  templateUrl: './otp-confirmation.component.html',
  styleUrls: ['./otp-confirmation.component.css']
})
export class OtpConfirmationComponent implements OnInit {
  userEmail: any;
  userReferralCode: any;
  loading = false;
  isRequired = false;
  otp: any = '';

  constructor(private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    let responseData = "";
    responseData = JSON.parse(localStorage.getItem('responseData'));
    this.userReferralCode=localStorage.getItem('referral');    
    this.userEmail = responseData['data'].emailId;
  }

  // validateOTP(otp) {
  //   // console.log(otp);    
  //   this.loading = true;
  //   if (otp == "") {
  //     this.isRequired = true;
  //     this.loading = false;
  //     return
  //   }
  //   var responseData = JSON.parse(localStorage.getItem('responseData'));
  //   var user = (localStorage.getItem('referral'));
  //   this.loginService.validateOTP(user, otp).subscribe(res =>       
  //     {                
  //     if (res.Status == 404) {
  //       this.loading = false;
  //       this.toastr.warning('Please Enter Correct Referral Code');
  //     } 
  //     else {
  //       if (res['data'].IsInvalid) {
  //         this.loading = false;
  //         this.toastr.warning('OTP is Invalid');
  //       }
  //       else if (res['data'].IsExpire) {
  //         this.loading = false;
  //         this.toastr.warning('OTP is Expired');
  //       } else {
  //         // var user = JSON.parse(localStorage.getItem('responseData'));
  //         localStorage.setItem('userDetails', JSON.stringify(res.data.userDetails));
  //         localStorage.setItem('signin_token', res.data.token)
  //         this.loading = false;

  //         // localStorage.removeItem('responseData')
  //         this.router.navigate(['view/mybusiness']);
  //       }
  //     }
  //   })
  // }
  validateOTP(otp) {
    // console.log(otp);    
    this.loading = true;
    if (otp == "") {
      this.isRequired = true;
      this.loading = false;
      return
    }
    var responseData = JSON.parse(localStorage.getItem('responseData'));
    var user = (localStorage.getItem('referral'));
    this.loginService.validateOTP(user, otp).subscribe(res => {
      console.log(res,'res');
      localStorage.setItem('userDetails', JSON.stringify(res.data.userDetails));
      localStorage.setItem('signin_token', res.data.token)
      this.loading = false;
      // localStorage.removeItem('responseData')
      this.router.navigate(['view/mycustomers']);
    },
    error=>{
      console.log(error,'error');
      
      if(error.status== 404){
        this.loading = false;
        this.toastr.warning('Please Enter Correct OTP');
      }
      else if(error.status== 400){
        this.loading = false;
        this.toastr.warning('OTP is Invalid');
      }
    }
    )
  }


  resendOPT(referralCode) {
    this.loginService.validateReferralCode(referralCode).pipe(map(res => {
      if(res.status == 200){
        this.toastr.success('OTP Resent Successfully');
      }
      localStorage.setItem('responseData', JSON.stringify(res))
    })).subscribe(
      res=>{},error=>{
        // console.log(error.error.Message);
        this.toastr.error(error.error.Message);
        
      }
    );
  }

  goBack() {
    this.router.navigate(['']);
  }
}
